import { useTranslations } from '@vocab/react';
import {
  TooltipRenderer,
  Text,
  Box,
  IconExperience,
} from 'braid-design-system';
import { useId, type FC } from 'react';

import translations from './.vocab';

import * as styles from './PriorityApplyBadge.css';

type PriorityApplyBadgeProps = {
  variant: 'tag' | 'badge';
};

export const PriorityApplyBadge: FC<PriorityApplyBadgeProps> = ({
  variant,
}) => {
  const { t } = useTranslations(translations);
  const id = useId();

  return (
    <TooltipRenderer
      id={id}
      placement="top"
      tooltip={
        <Text size="small">
          {t(
            'This applicant has marked your role as one of their top 3 for this month.',
          )}
        </Text>
      }
    >
      {({ triggerProps }) => (
        <Box
          {...triggerProps}
          className={
            variant === 'tag'
              ? styles.showPriorityApplyDesktop
              : styles.showPriorityApplyTablet
          }
          data={{ testid: 'priority-apply-badge' }}
        >
          <Text weight="strong" size="xsmall" tone="promote">
            <IconExperience />
            &nbsp;
            {t('Highly interested')}
          </Text>
        </Box>
      )}
    </TooltipRenderer>
  );
};
